import { FC } from "react";
import NewSvg from "../../public/icons/new.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const UsageNewIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><NewSvg/></span>;
